import { parseStartTimeValue } from "../components/StartTimeBlock";
import { DateTime } from "luxon";
import { useSelectedProjectStore } from "../../../../../stores/planner";

export const assignEditingFields = (
  bookings,
  projects,
  setDuration,
  setTentative,
  setLocation,
  setStartTime,
  setStartTimeWindowOpened,
  setUsesBudget,
  setBookingTask,
  setRepetition,
  setUsersToCreateBookings,
  setDeleteBookingsAfterSave,
  setRepetitionWindowOpened
) => {
  setDuration(bookings[0].duration / 60);
  setTentative(bookings[0].tentative);
  setLocation(bookings[0].location);
  setStartTime(parseStartTimeValue(bookings[0].start_time));
  setStartTimeWindowOpened(!!bookings[0].start_time?.toString());
  setUsesBudget(bookings[0].using_budget);
  setBookingTask(bookings[0].task_id);
  setRepetition({
    type: bookings[0].repetition?.[0]?.kind || null,
    every: bookings[0].repetition
      ? {
          value: bookings[0].repetition?.[0]?.every,
          label: bookings[0].repetition?.[0]?.every,
        }
      : { value: 1, label: 1 },
    endsAt: !!bookings[0].repetition?.[0]?.ends_on,
    endsAtDate: bookings[0].repetition?.[0]?.ends_on
      ? new Date(bookings[0].repetition?.[0]?.ends_on)
      : new Date(bookings[0].date),
    endsAfter: bookings[0].repetition ? !!bookings[0].repetition?.[0]?.ends_after : true,
    endsAfterNumber: bookings[0].repetition?.[0]?.ends_after || 5,
    ignoreWeekends: true,
  });
  setRepetitionWindowOpened(!!bookings[0].repetition?.[0]);
  setUsersToCreateBookings([]);
  setDeleteBookingsAfterSave(false);

  const project = projects.find((p) => p.id === bookings[0].project_id);

  if (project) {
    if (project.kind === "time_off") {
      useSelectedProjectStore.getState().setSelectedTimeOff(project);
      useSelectedProjectStore.getState().setProjectsType("time_off");
    } else {
      useSelectedProjectStore.getState().setSelectedProject(project);
      useSelectedProjectStore.getState().setProjectsType("default");
    }
  }
};

export const assignCreationFields = (
  setTentative,
  setLocation,
  setStartTime,
  setStartTimeWindowOpened,
  setUsesBudget,
  setBookingTask,
  setRepetition,
  setUsersToCreateBookings,
  setDeleteBookingsAfterSave,
  setRepetitionWindowOpened
) => {
  setTentative(false);
  setLocation(0);
  setStartTime(null);
  setStartTimeWindowOpened(false);
  setUsesBudget(true);
  setBookingTask(null);
  setRepetition({
    type: null,
    every: { value: 1, label: 1 },
    endsAt: true,
    endsAtDate: DateTime.now().plus({ months: 1 }).toJSDate(),
    endsAfter: false,
    endsAfterNumber: 5,
    ignoreWeekends: true,
  });
  setRepetitionWindowOpened(false);
  setDeleteBookingsAfterSave(false);
};
